import { Fragment, useEffect, useState, useRef } from "react";
import { Category, Product, Info, Review } from "../components/Card";

import { Tab, Indicator } from "../components/UI";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Carousel, HomeHeader, ProductSearch, Gallery } from "../components/";
import { mq, bp } from "../components/responsive";

import { Section, Grid, Col } from "../components/Layout";
import StepScroll from "../components/UI/StepScroll";
import { Nav } from "../components";

import Security from "../assets/security.svg";
import Flexible from "../assets/flexible.svg";
import Quality from "../assets/quality.svg";

import { useMediaQuery } from "../hooks";

const categories = [
  {
    _id: "1",
    title: "Phu Yen",
    image:
      "https://tour.dulichvietnam.com.vn/uploads/tour/1552989008_nha-trang-9.jpg",
  },
  {
    _id: "2",
    title: "Ha Giang",
    image:
      "https://ik.imagekit.io/tvlk/xpe-asset/AyJ40ZAo1DOyPyKLZ9c3RGQHTP2oT4ZXW+QmPVVkFQiXFSv42UaHGzSmaSzQ8DO5QIbWPZuF+VkYVRk6gh-Vg4ECbfuQRQ4pHjWJ5Rmbtkk=/2000812005063/Ha%2520Giang%2520Experience%2520-%25203D2N%2520Tour-b7a7fb3e-d2d5-49f4-8886-dcf6d03bac7a.jpeg?_src=imagekit&tr=c-at_max,h-512,q-60,w-720",
  },
  {
    _id: "3",
    title: "Da Lat",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSkgYTrVchmBThBlLHRG3sKsy3tP_A6Y3zOvw&usqp=CAU",
  },

  {
    _id: "4",
    title: "Da Nang",
    image:
      "https://danangfantasticity.com/wp-content/uploads/2020/03/da-nang-khong-to-chuc-le-ky-niem-45-nam-ngay-giai-phong.jpg",
  },
  {
    _id: "5",
    title: "Ha Noi",
    image:
      "https://www.nationalgeographic.com/content/dam/travel/Guide-Pages/asia/river-hanoi-vietnam.adapt.1900.1.jpg",
  },
  {
    _id: "6",
    title: "Sa Pa",
    image:
      "https://vietnam.travel/sites/default/files/styles/top_banner/public/2017-07/sapa.jpg?itok=64PxYHbz",
  },
];

const products = [
  {
    _id: "1",
    title: "Trang An",
    price: 120.0,
    location: "Ninh Binh",
    image: "/images/TrangAn.png",
    wished: false,
    rating: 3,
  },
  {
    _id: "2",
    title: "Ghenh Da Dia",
    price: 20.0,
    location: "Phu Yen",
    image: "/images/GhenhDaDia.jpg",
    wished: true,
    rating: 5,
  },
  {
    _id: "3",
    title: "Hoi an Accent Town",
    price: 35.0,
    location: "Quang Nam",
    image: "/images/hoian.jpg",
    wished: false,
    rating: 4.6,
  },

  {
    _id: "4",
    title: "Trang An",
    price: 65.0,
    location: "Ninh Binh",
    image: "/images/trangan.jpg",
    wished: false,
    rating: 1.2,
  },

  {
    _id: "5",
    title: "Mekong Delta",
    price: 265.0,
    location: "Mekong",
    image: "/images/mekongdelta.jpg",
    wished: false,
    rating: 3,
  },

  {
    _id: "6",
    title: "Hoi an Accent Town",
    price: 35.0,
    location: "Quang Nam",
    image: "/images/hoian.jpg",
    wished: false,
    rating: 4.6,
  },
];

const infos = [
  {
    heading: "Flexible time and destination",
    icon: Flexible,
    desc:
      "You can pick anytime you want. Every thing will organize optimizely to give you the best experience",
  },
  {
    heading: "Quality",
    icon: Quality,
    desc:
      "Our Local Ambassadors committed to excellent customer service and cultural experiences.",
  },
  {
    heading: "Security",
    icon: Security,
    desc:
      "We use the latest technologies to keep your money and your infomation safe, and stay ahead of vulnerabilities and exploitation attempts.",
  },
];

const reviews = [
  {
    avatar:
      "https://play-lh.googleusercontent.com/proxy/2tj1HTTkxfLUCHMYCMY7Ik_u9Dv-ctrQ7tteluo8MkL9bUzSFutbEcvkGroJxU6PTS84IHjfzCYjRsCflXcZ5k_CV2OAD2Al4i_fUCrb6cBVNvtB4TZhu97Z=w720-h405-rw",
    name: "Tadaaa",
    rate: "4",
    comment:
      "Tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa",
  },
  {
    avatar:
      "https://play-lh.googleusercontent.com/proxy/2tj1HTTkxfLUCHMYCMY7Ik_u9Dv-ctrQ7tteluo8MkL9bUzSFutbEcvkGroJxU6PTS84IHjfzCYjRsCflXcZ5k_CV2OAD2Al4i_fUCrb6cBVNvtB4TZhu97Z=w720-h405-rw",
    name: "Tadaaa",
    rate: "4.3",
    comment:
      "Tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa from tadaaa",
  },
];

const Home = () => {
  const [onTop, setOnTop] = useState(true);
  const [onScroll, setOnScroll] = useState(false);
  const lastY = useRef();

  const mediaQuery = useMediaQuery();

  useEffect(() => {
    const handleOnScroll = (e) => {
      const currentY = window.scrollY;
      const tmp = lastY.current || 0;
      lastY.current = currentY;
      if (
        tmp === currentY ||
        (tmp !== 0 && tmp < currentY) ||
        (currentY < tmp && currentY !== 0)
      )
        return;
      if (currentY - tmp > 0) setOnScroll((onScroll) => true);
      else setOnScroll((onScroll) => false);
    };

    const handleFirstScroll = (e) => {
      window.removeEventListener("scroll", handleFirstScroll);
      window.addEventListener("scroll", handleOnScroll);
      setOnTop(false);
    };

    window.addEventListener("scroll", handleFirstScroll);

    return () => {
      window.removeEventListener("scroll", handleOnScroll);
    };
  }, []);

  return (
    <Fragment>
      <Nav transparent={!onScroll || onTop} />

      <HomeHeader onTop={onTop} onScroll={onScroll} setOnTop={setOnTop}>
        {!onTop && (
          <div
            css={{
              border: "none",

              [mq.md]: {
                position: "absolute",
                display: "block",
                opacity: onScroll ? 0 : 1,
                transform: "translateX(-50%)",
                padding: "0",
                width: "100%",
                height: "fit-content",
                zIndex: 5,
                left: "50%",
                maxWidth: "60%",
                top: "50%",
              },
            }}
          >
            <ProductSearch />
          </div>
        )}
      </HomeHeader>

      <Section
        heading={{ content: "Top Destinations" }}
        style={{
          paddingTop: "6rem !important",
          paddingBottom: "6rem !important",
        }}
      >
        <StepScroll
          step={1}
          data={products}
          gutter="24px"
          render={(product) => <Product data={product} />}
          Indicator={({ scrollLeft, scrollRight, isLeft, isRight }) => (
            <Indicator
              styles={{
                position: "absolute ",
                right: "4rem",
                top: "6rem",

                [mq.xl]: {
                  right: "15rem",
                },
              }}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
              isLeft={isLeft}
              isRight={isRight}
            />
          )}
        />
      </Section>
      <Section
        heading={{ content: "Explore Our Vietnam" }}
        style={{
          paddingTop: "6rem !important",
        }}
      >
        <div css={{ display: "flex", justifyContent: "flex-start" }}>
          <Tab
            tabs={[
              {
                title: "Northern",
                component: (
                  <Grid gutter={{ xs: 4, md: 6, lg: 16 }}>
                    {categories.map((category) => (
                      <Col span={{ xs: 2, md: 6 }} key={category._id}>
                        <Category category={category} />
                      </Col>
                    ))}
                  </Grid>
                ),
              },
              {
                title: "Central",
                component: (
                  <Grid gutter={{ xs: 4, md: 6, lg: 16 }}>
                    {categories.map((category) => (
                      <Col span={{ xs: 2, md: 6 }} key={category._id}>
                        <Category category={category} />
                      </Col>
                    ))}
                  </Grid>
                ),
              },
              {
                title: "Southern",
                component: (
                  <Grid gutter={{ xs: 4, md: 6, lg: 16 }}>
                    {categories.map((category) => (
                      <Col span={{ xs: 2, md: 6 }} key={category._id}>
                        <Category category={category} />
                      </Col>
                    ))}
                  </Grid>
                ),
              },
            ]}
            style={{
              [mq.md]: {
                width: "calc(50% - 4rem)",
              },

              [mq.lg]: {
                width: "calc(50% - 2rem)",
              },
            }}
          />
          <Gallery
            title="Hanoi"
            images={[
              { src: "/images/hanoicard1.jpg", alt: "hanoi" },
              { src: "/images/hanoicard2.jpg", alt: "hanoi" },
              { src: "/images/hanoicard4.png", alt: "hanoi" },
              { src: "/images/hanoicard3.jpg", alt: "hanoi" },
            ]}
            style={{
              display: "none",
              width: "40%",
              maxWidth: "70rem",
              marginLeft: "5%",

              [mq.md]: {
                display: "block",
                height: "68rem",
              },
            }}
            height="64rem"
          />
        </div>
      </Section>
      <Section
        style={{
          backgroundColor: "#DEF4E5",
          marginTop: "5rem",
        }}
        heading={{
          content: "Why 2SJourney",
          style: { color: "#50976A", textAlign: "center" },
        }}
      >
        <Grid>
          {infos.map((info, i) => (
            <Col key={i} span={{ xs: 4, md: 4, lg: 4 }}>
              <Info heading={info.heading} icon={info.icon} desc={info.desc} />
            </Col>
          ))}
        </Grid>
      </Section>
      <Section
        heading={{
          content: "Meet Our Local  Ambassador",
        }}
      >
        <div>
          <Carousel
            direction="vertical"
            indicatorType="dots"
            render={(item) => <img src={item.src} alt={item.alt} />}
            collapse={mediaQuery.up(bp.md)}
            items={[
              {
                src: "/images/Sky.jpg",
                alt: "Sky",
              },

              {
                src: "/images/Rosie.jpg",
                alt: "Rosie",
              },
              {
                src: "/images/Phobe.jpg",
                alt: "Phobe",
              },
              {
                src: "/images/Sky.jpg",
                alt: "Sky",
              },

              {
                src: "/images/Rosie.jpg",
                alt: "Rosie",
              },
              {
                src: "/images/Phobe.jpg",
                alt: "Phobe",
              },
            ]}
          />
        </div>
      </Section>
      <Section
        heading={{
          content: "Tourists talk about us",
        }}
        style={{
          backgroundColor: "#FAFBFB",

          [mq.xl]: {
            padding: "12rem 30rem !important",
          },
        }}
      >
        <StepScroll
          step={1}
          data={reviews}
          gutter="24px"
          render={(review) => <Review review={review} />}
          elementWidth="100%"
          Indicator={({ scrollLeft, scrollRight, isLeft, isRight }) => (
            <Indicator
              styles={{
                position: "absolute ",
                right: "20px",
                top: "6rem",

                [mq.xl]: {
                  right: "30rem",
                  top: "12rem",
                },
              }}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
              isLeft={isLeft}
              isRight={isRight}
            />
          )}
        />
      </Section>
    </Fragment>
  );
};

export default Home;
